export default __webpack_public_path__ + "static/media/icone-instagram.32b30ae0.svg";